import React from "react"; // Required for JSX even if not explicitly used
import { Button } from '../components/ui/button';
import { ChevronRight } from 'lucide-react';

interface ClickableSettingRowProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export default function ClickableSettingRow({ label, onClick, disabled }: ClickableSettingRowProps) {
  return (
    <Button
      variant="ghost" // Use ghost variant for a clean, button-like row
      onClick={onClick}
      disabled={disabled}
      className="w-full justify-between rounded-none border-b border-[color:var(--jr-border)] px-4 py-6 text-[var(--jr-text)] hover:bg-[color:rgba(255,255,255,0.03)]" // Style as a full-width row
    >
      <span className="text-base font-normal">{label}</span>
      <ChevronRight size={20} className="text-[color:var(--jr-text-muted)]" />
    </Button>
  );
}
